import { render, staticRenderFns } from "./buyOverview.vue?vue&type=template&id=119ccf50&scoped=true"
import script from "./buyOverview.vue?vue&type=script&lang=js"
export * from "./buyOverview.vue?vue&type=script&lang=js"
import style0 from "./buyOverview.vue?vue&type=style&index=0&id=119ccf50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119ccf50",
  null
  
)

export default component.exports